import React from "react";
import { Box, Link, Typography } from "@mui/material";
import CustomTooltip from "./custom-tooltip.jsx";
import "../../../../styles/analytics/total-table.scss";
import { formatPercentage } from "../utils.js";

const PercentBox = ({ percent }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      color: percent > 0 ? "#16A34A" : "#4B5563",
    }}
  >
    {Number.isNaN(percent) ? (
      "N/A"
    ) : (
      <>
        <i
          className={`percent-icon fa ${
            percent > 0
              ? "fa-caret-up"
              : percent === 0
              ? "fa-minus"
              : "fa-caret-down"
          } `}
          aria-hidden="true"
        ></i>
        <Typography component="span" className="percentage-label">
          {percent >= 0 ? percent : -percent}%
        </Typography>
      </>
    )}
  </Box>
);

const TotalTable = ({ headers, rows, title, disableCompareData, percentMetric = false }) => {
  let showInfoIcon = false;

  const renderDisableCompareDataContent = (disableCompareData, heading) => {
    if (disableCompareData) {
      showInfoIcon = true;
      return "N/A";
    } else {
      return (
        <PercentBox percent={heading.percent.toFixed(2).replace(/\.00$/, "")} />
      );
    }
  };

  return (
    <Box className="total-table-container">
      <table>
        <thead>
          <tr className="metric-header">
            <th className="title">{title}</th>
            {disableCompareData ? <th>Total</th> : <th>Current Period</th>}
            {!disableCompareData && <th>Comparison Period</th>}
            {!disableCompareData && <th>% Change</th>}
          </tr>
          {headers.map((header) => (
            <tr className="metric-subheader" key={`header-${header.title}`}>
              {header.tooltip ? (
                <CustomTooltip title={header.tooltip} placement="top-start">
                  <th>{header.title}</th>
                </CustomTooltip>
              ) : (
                <th>{header.title}</th>
              )}
              <th>
                {percentMetric ? 
                formatPercentage(header.currentTotalCount) :
                header.currentTotalCount.toFixed(2).replace(/\.00$/, "")}
              </th>
              {!disableCompareData && (
                <th>
                  {percentMetric ? 
                  formatPercentage(header.comparisonTotalCount) :
                  header.comparisonTotalCount.toFixed(2).replace(/\.00$/, "")}
                </th>
              )}
              {!disableCompareData && (
                <th>
                  {renderDisableCompareDataContent(disableCompareData, header)}
                </th>
              )}
            </tr>
          ))}
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={`row-${row.title}`}>
              {showInfoIcon ? (
                <td style={{ color: "grey" }}>
                  {row.title}
                  <CustomTooltip
                    title={
                      <>
                        This data is currently not available due to platform
                        restrictions.{" "}
                        <Typography
                          component={Link}
                          href="https://cloudcampaignsupport.zendesk.com/hc/en-us/articles/32397040236691-Why-Social-Media-Metrics-May-Be-Missing-from-Your-Analytics-Dashboard"
                          color="Blue"
                          underline="hover"
                        >
                          Learn more
                        </Typography>
                      </>
                    }
                  >
                    <span>
                      <i
                        class="fa fa-info-circle info-icon"
                        aria-hidden="true"
                        style={{ color: "#7787f7", paddingLeft: 5 }}
                      ></i>
                    </span>
                  </CustomTooltip>
                </td>
              ) : (
                <td>{row.title}</td>
              )}
              <td>
                {percentMetric ? formatPercentage(row.total.currentTotalCount) : row.total.currentTotalCount.toFixed(2).replace(/\.00$/, "")}
              </td>
              {!disableCompareData && (
                <td>
                  {percentMetric ? 
                  formatPercentage(row.total.comparisonTotalCount) : 
                  row.total.comparisonTotalCount.toFixed(2).replace(/\.00$/, "")}
                </td>
              )}
              {!disableCompareData && (
                <td>
                  {renderDisableCompareDataContent(disableCompareData, row)}
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </Box>
  );
};

export default TotalTable;
